/**
 * Store-link routing for the force-update screen.
 *
 * The store URL itself comes from the backend (`/app-config?platform=…`) so a
 * new App Store ID does not require an app rebuild. This module only decides
 * how to open it: native store app where possible, browser otherwise.
 */

const ANDROID_PACKAGE = 'com.eveebuddy.mobile';

export interface StoreTarget {
  url: string;
  /** Capacitor routes '_system' to the OS handler, '_blank' to a browser tab. */
  target: '_system' | '_blank';
}

export function resolveStoreTarget(platform: string, storeUrl: string): StoreTarget | null {
  if (!storeUrl) return null;

  if (platform === 'android') {
    // market:// opens the Play Store app directly instead of a browser chooser.
    return { url: `market://details?id=${ANDROID_PACKAGE}`, target: '_system' };
  }

  if (platform === 'ios') {
    // itms-apps:// opens the App Store app. Only rewrite genuine apps.apple.com
    // links — anything else is passed through untouched.
    const url = storeUrl.startsWith('https://apps.apple.com/')
      ? storeUrl.replace(/^https:\/\//, 'itms-apps://')
      : storeUrl;
    return { url, target: '_system' };
  }

  return { url: storeUrl, target: '_blank' };
}
